// extracted by mini-css-extract-plugin
export default {"card":"ProductCard_card__906fU","section":"ProductCard_section__0o1ka","link":"ProductCard_link__0yHF1","label":"ProductCard_label__kK-x2","badge":"ProductCard_badge__RL21e"};